import { render } from "./ErrorMessage.vue?vue&type=template&id=38dc7746&scoped=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"

import "./ErrorMessage.vue?vue&type=style&index=0&id=38dc7746&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/derbyweb.dev/todo.derbyweb.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38dc7746"]])

export default __exports__